import React from "react";

const styles = {
  root: {
    position: "relative",
  },
  content: {
    padding: "3px 0px",
  },
};

export default ({ id, label, children, style = {} }) => {
  const classes = styles;
  return (
    <div style={{ position: "relative", marginTop: "8px", ...style }}>
      <div htmlFor={id}>{label}</div>
      <div style={classes.root}>
        <div id={id} style={classes.content} className="form-field">
          {children}
        </div>
      </div>
    </div>
  );
};
